import QuestionHeader from "../component/QuestionHeader";
import QuestionFooter from "../component/QuestionFooter";
import {useEffect, useState} from "react";
import TextareaAutosize from 'react-textarea-autosize';
import {useParams} from "react-router-dom";
import {useQuestion} from "../../../../redux/Reducers/QuestionReducer";
import useForm from "../../../../hooks/useForm";
import URLS from "../../../../API/Axios/URLS";
import AnswerDropDown from "../component/AnswerDropDown";
import {tokenizeSentence} from "../../../../utils/utils";
import FormNoneFieldErrors from "../../../../components/Form/FormNoneFieldErrors";



export default function HighlightTheAnswer({className, ...props}) {
    const {id} = useParams()
    const [response, setResponse] = useState(null)
    const {question, questionActions, isLoading} = useQuestion()
    const [showModal, setShowModal] = useState(false)
    const [form, error, loading, setFormData, actions] = useForm({
        questionId: id,
        answer: "",
    },true)


    function submitAnswer() {
        if (form?.answer.length === 0) {
            actions.setError({
                non_field_errors: ["Please highlight the answer"]
            })
            return
        }
        actions.post(URLS.genericQuestionView).then(response => {
            setResponse(response?.data)
            setShowModal(true)
        })


    }

    useEffect(() => {
        questionActions.loadQuestions(id)
    }, [id]);

    return (
        <div className={`rounded-lg shadow-lg p-4 ${className}`}>
            <QuestionHeader {...question}
                            timeLimit={question?.timeLimit && question?.timeLimit + 10000}

            />
            <div className={" flex flex-col items-center md:flex-row p-2 py-8 justify-center gap-8"}>

                <div className={"flex flex-1 px-8 flex-col gap-4"}>
                    <p
                        tabIndex="0"
                        onMouseUp={(e) => {
                            // Get the selected text
                            const selectedText = window.getSelection().toString();
                            setFormData({
                                answer: selectedText
                            })

                        }}
                        onKeyUp={(e) => {
                            if (e.key === 'Shift') {
                                // Get the selected text
                                const selectedText = window.getSelection().toString();
                                setFormData({
                                    answer: selectedText
                                })
                            }
                        }}


                        className={"text-bawa   p-2 focus:border-0 border-0 bg-gray-200 select-text "}>{question?.text}</p>
                    <p className={"text-bawa   p-2 font-semibold "}>{question?.questionText}</p>
                    <TextareaAutosize
                        minRows={10}
                        placeholder=""
                        value={form?.answer}
                        disabled
                        className="w-full rounded-lg text-bawa   border-[1.5px] text-black-2 dark:text-white border-b-graydark bg-white py-2 px-2 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    ></TextareaAutosize>
                    <div className={"flex w-full flex-row-reverse"}>
                        Word Count : {tokenizeSentence(form?.answer).length}
                    </div>
                    <FormNoneFieldErrors className={"mt-3"} errors={error?.answer || error?.non_field_errors || error?.time}/>

                </div>





            </div>
            <QuestionFooter
                loading={loading}
                disabled={!!response}
                submitText={"Practice +1"}
                onClickSubmit={submitAnswer}
                className={"mx-4 my-2"}/>
            <AnswerDropDown
                headerTitle={"Answer"}
                justifications={
                    question?.answerText
                }
            />

        </div>

    )
}
